import { DefaultTheme } from 'styled-components';

export type ThemeSections = 'colors' | 'typography' | 'webColors';

const defaultTheme: DefaultTheme = {
    typography: {
        fontSize: '15px',
        fontBody: 'urw-form',
        fontHeading: 'urw-form',
        f1400family: 'urw-form', // Body
        f1500family: 'urw-form',
        f1700family: 'urw-form',
        f2400family: 'urw-form', // Headers
        f2700family: 'urw-form',
        f3300family: 'urw-form', // Neutral (Control panel + cart + footer + tiny texts)
        f3400family: 'urw-form',
        f3500family: 'urw-form',
        f3700family: 'urw-form',
    },
    colors: {
        main: '#231F20', // Main color - top bar, colored fills etc
        mainText: '#fcfcfc', // Text on main
        accent: '#BC9B6A', // Main accent - buttons, quotes.
        accentText: '#FFF', // Text on accent - ie: ligth if accent is dark
        attention: '#648F78', // Secondary accent - Special buttons (buy now!), badges.
        attentionText: '#FFF', // Text on attention - ie: dark if light attention

        //product card background color
        productCardBackgroundColor: '#fff', //default

        // Additional text colors
        text: '#2f2f2fff',
        textLight: '#757575',
        textWhite: '#fcfcfc',
        textFaded: '#9E9B97',
        textDisabled: '#cfcecc',

        // Fill colors
        fill: '#F4F4F4', // Set in CMS
        fillLight: '#FBFBFB', // almost white but not quite. Not overridden.
        fillMedium: '#EAEAEA', // derived from fill * 0.04
        fillWhite: '#fff', // should not be overriden
        fillBlack: '#231F20', // should not be overriden
        fillSecondary: '#231F20', // Set in CMS or derived from fill * 0.8 - Used in footer
        fillSecondaryText: '#F4F4F4', // Set in CMS
        fillHover: '#f5f5f5', // should not be overriden
        fillGray: '#e9e9e9', // should not be overriden

        transparent: 'transparent',
        transparentBg: '#dce2ed', // '#dee3e4', // '#eaeff5'

        border: '#CFCEC8',
        borderLight: '#e9e9e9',
        borderGray: '#ececec',
        borderDark: '#e2e2e2',

        success: '#7acf8b',
        error: '#ff6e6e',
        warning: '#eed447',

        pending: '#ADD2DE',
        approved: '#A7C3A4',
        rejected: '#DF5252',

        sale: '#ff6e6e',
        buy: '#648F78',
        buyText: '#FFFFFF',
        priceText: '#648F78',
        sustainable: '#648F78',
        disabled: '#EFEFEF',
        socialMedia: '#BC9B6A', //Icons

        white: '#fff', // Non-changable white

        link: '#013777', // Non-changable blue for some generic links
    },
    webColors: {
        beige: '#fde3a7',
        black: '#000',
        blue: '#3e94cf',
        brown: '#ba7e4a',
        clear: '#ffffff40',
        gold: '#e0d7b0',
        green: '#3ead6c',
        grey: '#bdc3c7',
        navyblue: '#405870',
        orange: '#f29d3a',
        pink: '#f1a9a0',
        purple: '#a6589d',
        red: '#eb4b3b',
        silver: '#d2d7d3',
        white: '#ffffff',
        yellow: '#fff270',
    },
    shadows: {
        soft: 'box-shadow: 0 0px 14px rgb(0 0 0 / 6%);',
        medium: 'box-shadow: 0px 0px 16px 0 rgba(0,0,0,0.12);',
        high: 'box-shadow: 0px 0px 24px 0 rgba(0,0,0,0.16);',
    },
    media: {
        xs: '@media screen and (min-width: 480px)',
        xsBelow: '@media screen and (max-width: 479px)',
        sm: '@media screen and (min-width: 640px)',
        smBelow: '@media screen and (max-width: 639px)',
        md: '@media screen and (min-width: 768px)',
        mdBelow: '@media screen and (max-width: 767px)',
        lg: '@media screen and (min-width: 1025px)',
        lgBelow: '@media screen and (max-width: 1024px)',
        lgmd: '@media screen and (min-width: 1300px)',
        lgmdBelow: '@media screen and (max-width: 1299px)',
        xl: '@media screen and (min-width: 1696px)',
        xlBelow: '@media screen and (max-width: 1696px)',
    },
    borders: {
        underline1: 'border-bottom: 1px solid',
        underline2: 'border-bottom: 2px solid',
        radius: '4px',
    },
    transitions: {
        bez: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    },
    breakpoints: {
        min: 0,
        xs: 480,
        sm: 640,
        md: 768,
        lg: 1025,
        lgmd: 1300,
        xl: 1696,
    },
};

export default defaultTheme;
